import { createSelector } from 'reselect'
import getMembersSquadSelect from 'modules/squad/redux/selectors/get-members'

const getMembersCountSquadSelect = createSelector(
  getMembersSquadSelect,
  (members) => {
    return members.length
  }
)

export default getMembersCountSquadSelect
